import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import { BrandMark } from './BrandMark';

type PublicTab = {
  path: string;
  label: string;
};

export function PublicTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const tabs: PublicTab[] = useMemo(
    () => [
      { path: '/register', label: t('publicNav.connect') },
      { path: '/add-server', label: t('publicNav.addServer') },
      { path: '/keys', label: t('publicNav.masterKey') }
    ],
    [t]
  );

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="border-b border-[color:var(--border-soft)] bg-[rgba(255,252,250,0.72)] backdrop-blur-xl">
      <div className="page-shell max-w-4xl">
        <div className="flex flex-col gap-3 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl border border-[color:var(--border-soft)] bg-white/80">
              <BrandMark size="sm" />
            </div>
            <div>
              <div className="section-eyebrow">Circlus</div>
              <div className="text-sm font-medium text-[color:var(--text-muted)]">{t('register.subtitle')}</div>
            </div>
          </div>

          <div className="flex gap-2 overflow-x-auto pb-1 sm:pb-0">
          {tabs.map((tab) => (
            <button
              key={tab.path}
              type="button"
              onClick={() => navigate(tab.path)}
              className={`shrink-0 rounded-full border px-3 py-1.5 text-sm font-medium transition-all ${
                isActive(tab.path)
                  ? 'border-primary-200 bg-primary-50 text-primary-700 shadow-[inset_0_0_0_1px_rgba(232,92,63,0.12)]'
                  : 'border-[color:var(--border-soft)] bg-white/80 text-[color:var(--text-muted)] hover:border-[color:var(--border-strong)] hover:bg-white'
              }`}
            >
              {tab.label}
            </button>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
}
